import React from 'react';
import { TAccessServiceType } from '../../@types/Access';
import AccessServiceIcon from '../common/AccessServiceIcon';
import './AccessServiceBadge.scss';

export interface IAccessServiceBadgeProps {
  type: TAccessServiceType;
  iconOnly?: boolean;
}

const AccessServiceBadge = ({ type, iconOnly = false }: IAccessServiceBadgeProps) => {
  const serviceValues = {
    audio_description: {
      label: 'Audio Description only',
    },
    audio_description_and_full_audio: {
      label: 'Audio Description + Full Audio',
    },
    closed_captions: {
      label: 'Closed Captioning',
    },
    amplified_audio: {
      label: 'Amplified Audio',
    },
    sign_language: {
      label: 'Sign Language',
    },
  };

  const targetService = serviceValues[type];

  return (
    <div className="access-service-badge" aria-label={targetService.label}>
      <AccessServiceIcon serviceType={type} />{' '}
      {!iconOnly && (
        <p className="access-service-badge__label">{targetService.label}</p>
      )}
    </div>
  );
};

export default AccessServiceBadge;
